import axios from "axios";

export interface AnswerResp {
   blockId: string;
   blockVersionId: string;
   createdAt: string;
   data: any;
   id: string;
   metadata: any;
   updatedAt: string;
}

export default class AnswersApi {
   public static getAll = async (flowId: string): Promise<AnswerResp[]> => {
      const response = await axios.get(`/flows/${flowId}/answers`);
      return response.data;
   };

   // Token is used to authorise users in anonymous public flows
   public static getAllWithToken = async (flowId: string, token: string): Promise<AnswerResp[]> => {
      const response = await axios.post(`/p/flows/${flowId}/answers`, { token });
      return response.data;
   };

   // The BE will send back the updated answer and we update the store
   // Helpful for: When you press the Previous button, check the answer for that block and if we have an answer, the Next button on the block should be enabled
   public static submit = async (blockVersionId, data): Promise<AnswerResp> => {
      const response = await axios.put(`/block-versions/${blockVersionId}/answers`, { data });
      return response.data;
   };

   // Token is used to authorise users in anonymous public flows
   public static submitWithToken = async (
      blockVersionId,
      data,
      token?: string | null,
      config = {}
   ): Promise<AnswerResp> => {
      const response = await axios.put(`/p/block-versions/${blockVersionId}/answers`, { data, token }, { ...config });
      return response.data;
   };
}
